module.exports = __webpack_public_path__ + "img/close.e08b1242.svg";